// Components
export { GuestUser } from 'shared/ui/GuestUser';

// Types
export type { GuestUserProps } from 'shared/ui/GuestUser';
